import { render, staticRenderFns } from "./remoteLog.vue?vue&type=template&id=065a880a&scoped=true&"
import script from "./remoteLog.vue?vue&type=script&lang=js&"
export * from "./remoteLog.vue?vue&type=script&lang=js&"
import style0 from "./remoteLog.vue?vue&type=style&index=0&id=065a880a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a880a",
  null
  
)

export default component.exports